<template>
  <div class="form">
    <form
      id="getScoutedForm"
      class="w-100"
      method="POST"
      enctype="multipart/form-data"
    >
      <input-group
        :formInputs="formInputs"
        :formData="formData"
        :isFileUpload="false"
      />

      <div class="row bank-info mlr--5">
        <div class="col-12 text-center">
          <h4>
            Dados Bancários
          </h4>
          <p class="desc mb-0">De prerência CAIXA e não pode ser de terceiros</p>
        </div>
      </div>

      <input-group
        :formInputs="formBankInfo"
        :formData="formData"
        :isFileUpload="false"
      />

      <div class="row measures mlr--5">
        <div class="col-12 text-center">
          <h4>
            Medidas
          </h4>
        </div>
      </div>

      <input-group
        :formInputs="formSelects"
        :formData="formData"
        :isFileUpload="false"
      />

      <div class="row photos-intro mlr--5">
        <div class="col-12 text-center">
          <h4>
            Fotos
          </h4>
          <p class="desc mb-0">
            As fotos não podem estar de óculos, biquíni, com copo na mão,
            no espelho, fazendo biquinho ou com outras pessoas</p>
        </div>
      </div>

      <input-group
        :formInputs="formImages"
        :formData="formData"
        :filesData="filesData"
        :isFileUpload="true"
      />

      <div class="sbmt-btn text-center">
        <p class="desc mb-0">
          Leia nossos <a href="#" target="_blank">Termos e Condições</a> | <a href="#" target="_blank">Termos de Uso</a>
        </p>

        <div class="confirm position-relative">
          <input class="mr-1" type="checkbox" name="confirmForm" id="confirmForm" v-model="confirmForm">
          <p class="desc mb-0">
            Eu concordo com os termos e condições deste formulário.
          </p>
          <p v-if="!confirmForm && checkBoxMsg !== ''" class="error-msg confirm">
            {{ checkBoxMsg }}
          </p>
          <p v-else-if="!confirmForm && consoleMsg !== ''" class="error-msg confirm">
            {{ consoleMsg }}
          </p>
          <p v-else-if="successMsg !== ''" class="error-msg confirm">
            {{ successMsg }}
          </p>
        </div>

        <button v-if="!loading && successMsg === ''" @click.prevent="sendMail()" type="submit">Enviar</button>
        <img v-if="loading" src="/src/assets/img/loading.svg" alt="Enviando" />
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import InputGroup from './InputGroup'
import options from '../assets/options/options'

export default {
  inject: ['$validator'],

  props: {
    joboptions: {
      type: Object,
      required: true
    },
    inputs: {
      type: Array,
      required: true
    },
    bankInfo: {
      type: Array,
      required: true
    },
    selects: {
      type: Array,
      required: true
    },
    images: {
      type: Array,
      required: true
    }
  },

  components: {
    'input-group': InputGroup
  },

  data () {
    return {
      formData: {},
      filesData: {},
      options: options,
      confirmForm: false,
      loading: false,
      consoleMsg: '',
      checkBoxMsg: '',
      successMsg: '',
      labels: {
        job: {
          label: 'Cargo'
        },
        name: {
          label: 'Nome Completo'
        },
        email: {
          label: 'Email'
        },
        gender: {
          label: 'Gênero'
        },
        birthdate: {
          label: 'Data de Nascimento'
        },
        mobile: {
          label: 'Celular'
        },
        langs: {
          label: 'Idiomas Fluentes'
        },
        father: {
          label: 'Nome do Pai'
        },
        address: {
          label: 'Endereço'
        },
        mother: {
          label: 'Nome da Mãe'
        },
        id_num: {
          label: 'RG'
        },
        id_fiscal_num: {
          label: 'CPF'
        },
        emergency_contact: {
          label: 'Nome do Contato de Emergência'
        },
        emergency_contact_phone: {
          label: 'Telefone do Contato de Emergência'
        },
        bank: {
          label: 'Banco'
        },
        bank_agency: {
          label: 'Agência'
        },
        bank_account_type: {
          label: 'Tipo de Conta'
        },
        bank_account: {
          label: 'Conta'
        },
        height: {
          label: 'Altura'
        },
        jeans_1: {
          label: 'Manequim'
        },
        // jeans_2: {
        //   label: 'Manequim A'
        // },
        // jeans_unit: {
        //   label: 'Unidade de Medida'
        // },
        shoes: {
          label: 'Sapato'
        },
        // shoes_unit: {
        //   label: 'Unidade de Medida'
        // },
        photo_1: {
          label: 'Rosto'
        },
        photo_2: {
          label: 'Rosto'
        },
        photo_3: {
          label: 'Corpo Inteiro'
        },
        photo_4: {
          label: 'Corpo Inteiro'
        },
        photo_5: {
          label: 'Corpo Inteiro'
        }
      }
    }
  },

  computed: {
    formInputs () {
      return this.inputs
    },
    formBankInfo () {
      return this.bankInfo
    },
    formSelects () {
      return this.selects
    },
    formImages () {
      return this.images
    }
  },

  mounted () {
    // console.log(Object.keys(this.options.langs).find(key => this.options.langs[key] === 'AR'))
    // const test = ['AR', 'EN']
    // test.forEach(lang => {
    //   console.log(Object.keys(this.options.langs).find(key => this.options.langs[key] === lang))
    // })
  },

  methods: {
    sendMailTest () {
      const formArray = Object.keys(this.formData)
      const imagesArray = Object.values(this.formImages)

      const data = new FormData()

      // formArray.forEach(input => {
      //   data.append(input.toString(), this.formData[input])
      // })

      // data.append('job', this.job)

      formArray.forEach(input => {
        switch (input) {
          case 'job':
            data.append(input.toString(),
              JSON.stringify([{
                value: this.formData[input],
                emailData: this.joboptions['category'][this.formData[input]],
                label: 'Cargo'
              }])
            )
            break

          case 'lang':
            const langs = this.formData['lang']
              .map(item => Object.values(this.options.langs)
                .find(i => i === item))
              .map(item => this.options.translate_langs_check['en'][item])

            const langsIds = []

            this.formData['langs'].forEach(lang => {
              langsIds.push(Object.keys(this.options.langs).find(key => this.options.langs[key] === lang))
            })

            data.append(input.toString(),
              JSON.stringify([{
                value: langsIds,
                emailData: langs.join(', '),
                label: this.labels[input].label
              }])
            )
            break

          case 'bank_account_type':
            const account = this.formData['bank_account_type'] === 1 ? 'Conta corrente' : 'Conta poupança'

            data.append(input.toString(),
              JSON.stringify([{
                value: this.formData[input],
                emailData: account,
                label: this.labels[input].label
              }])
            )
            break

          default:
            data.append(input.toString(),
              JSON.stringify([{
                value: this.formData[input],
                label: this.labels[input].label
              }])
            )
            break
        }
      })

      imagesArray.forEach(image => {
        if (document.getElementById(`photo_${image.id}`).files[0] !== null) {
          data.append(`photo_${image.id}`, document.getElementById(`photo_${image.id}`).files[0])
        }
      })

      // Display the key/value pairs
      for (const pair of data.entries()) {
        console.log(pair[0] + ': ' + pair[1])
      }
    },

    sendMail () {
      // if (this.confirmForm === true) {
      this.$validator.validate().then(result => {
        if (!result) {
          console.log('Form validation error')

          this.consoleMsg = 'Confira os campos do formulário e tente enviar novamente'
        } else {
          if (this.confirmForm === true) {
            this.loading = true
            this.consoleMsg = ''

            const formArray = Object.keys(this.formData)
            const imagesArray = Object.values(this.formImages)

            const data = new FormData()

            data.append('job', this.job)

            formArray.forEach(input => {
              switch (input) {
                case 'job':
                  data.append(input.toString(),
                    JSON.stringify([{
                      value: this.formData[input],
                      emailData: this.joboptions['category'][this.formData[input]],
                      label: 'Cargo'
                    }])
                  )
                  break

                case 'langs':
                  const langs = this.formData['langs']
                    .map(item => Object.values(this.options.langs)
                      .find(i => i === item))
                    .map(item => this.options.translate_langs_check['en'][item])

                  const langsIds = []

                  this.formData['langs'].forEach(lang => {
                    langsIds.push(Object.keys(this.options.langs).find(key => this.options.langs[key] === lang))
                  })

                  data.append(input.toString(),
                    JSON.stringify([{
                      value: langsIds,
                      emailData: langs.join(', '),
                      label: this.labels[input].label
                    }])
                  )
                  break

                case 'bank_account_type':
                  const account = this.formData['bank_account_type'] === 1 ? 'Conta corrente' : 'Conta poupança'

                  data.append(input.toString(),
                    JSON.stringify([{
                      value: this.formData[input],
                      emailData: account,
                      label: this.labels[input].label
                    }])
                  )
                  break

                default:
                  data.append(input.toString(),
                    JSON.stringify([{
                      value: this.formData[input],
                      label: this.labels[input].label
                    }])
                  )
                  break
              }
            })

            imagesArray.forEach(image => {
              if (document.getElementById(`photo_${image.id}`).files[0] !== null) {
                data.append(`photo_${image.id}`, document.getElementById(`photo_${image.id}`).files[0])
              }
            })

            axios.post('https://website.managerfashion.net/service/applies-mail/eventos61/get-scouted/', data)
              .then(response => {
                this.successMsg = 'Formulário enviado! Em breve entraremos em contato.'

                setTimeout(() => {
                  this.loading = false
                }, 1000)

                console.log('Mail sended')
              })
              .catch(response => {
                this.consoleMsg = 'Algo deu errado ao enviar a mensagem. Tente novamente mais tarde :/'

                setTimeout(() => {
                  this.loading = false
                }, 1000)

                console.log('Error sending mail')
              })
          } else {
            this.checkBoxMsg = 'Você deve aceitar as condições antes de enviar o formulário!'
          }
        }
      })
      // } else {
      //   this.checkBoxMsg = 'Você deve aceitar as condições antes de enviar o formulário!'
      // }
    }
  }
}
</script>

<style lang="scss">
.form {
  width: 100%;
  max-width: 792px;

  form#getScoutedForm {
    .bank-info,
    .measures,
    .photos-intro{
      margin-top: 40px;
      margin-bottom: 30px;
    }

    .sbmt-btn {
      .confirm{
        display: flex;
        align-items: center;
        justify-content: center;
      }

      button {
        margin-top: 40px;
        padding: 10px 40px;
        font-size: 20px;
        font-weight: 500;
        text-transform: uppercase;
        color: #884E79;
        background: white;
        border: none;
        transition: all 0.25s ease;

        &:hover {
          transform: scale(1.1, 1.1);
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DynamicForm.vue